<template>
    <div class="more_info">
        <div v-for="group in groups" :key="group.id" class="info_row">
            <v-select
                :options="group.attributes.filter(attribute => !attribute.hide)"
                :value="group.selectedValue"
                label="value"
                :reduce="item => item.id"
                :clearable="false"
                :searchable="false"
                :placeholder="
                    `${group.name} ${group.unit ? `[${group.unit}]` : ''}`
                "
                dir="rtl"
                @input="onSelect($event, group.id)"
            >
                <template #open-indicator>
                    <b class="button" />
                </template>
            </v-select>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';

export default {
    components: {
        vSelect
    },

    props: {
        variants: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            groups: []
        };
    },

    watch: {
        variants: {
            handler() {
                const groups = [];

                for (const { attributes } of this.variants) {
                    for (const attribute of attributes) {
                        const { group, value, id } = attribute;

                        const groupIndex = groups.findIndex(
                            item => item.id === group.id
                        );

                        const currentGroup = groups[groupIndex];

                        if (!currentGroup) {
                            groups.push({
                                id: group.id,
                                name: group.name,
                                unit: group.unit,
                                attributes: [{ value, id }]
                            });

                            continue;
                        }

                        const isAtributeAdded = currentGroup.attributes.find(
                            item => item.id === id
                        );

                        if (!isAtributeAdded) {
                            groups[groupIndex].attributes.push({ value, id });
                        }
                    }
                }

                groups[0].displayed = true;

                this.groups = [...groups].sort(
                    (a, b) => b.attributes.length - a.attributes.length
                );
            },
            immediate: true
        }
    },

    methods: {
        onSelect(value, groupId) {
            const index = this.groups.findIndex(item => item.id === groupId);

            this.groups[index].selectedValue = value;

            this.groups = this.groups.map((group, i) => ({
                ...group,
                selectedValue: i <= index ? group.selectedValue : null,
                displayed: i <= index + 1
            }));

            this.checkVariant(index);

            if (this.groups[index + 1]) {
                const possibleVariants = this.variants.filter(variant =>
                    variant.attributes.find(item => item.id === value)
                );

                this.groups[index + 1].attributes = this.groups[
                    index + 1
                ].attributes.map(attribute => ({
                    ...attribute,
                    hide: !possibleVariants.find(variant =>
                        variant.attributes.find(
                            item => item.id === attribute.id
                        )
                    )
                }));

                const { attributes } = this.groups[index + 1];

                if (!attributes.filter(attribute => !attribute.hide).length) {
                    this.groups[index + 1].displayed = false;
                }
            }
        },

        checkVariant(currentIndex) {
            const selectedAttributes = this.groups
                .filter(item => item.displayed && item.selectedValue)
                .map(item => item.selectedValue);

            const variants = this.variants.filter(
                item => item.attributes.length === selectedAttributes.length
            );

            if (!variants.length) {
                return this.$emit('variant-changed', null);
            }

            const variant = variants.find(item => {
                const attributes = item.attributes.map(
                    attribute => attribute.id
                );

                return attributes.every(attribute =>
                    selectedAttributes.includes(attribute)
                );
            });

            if (!variant && !this.groups[currentIndex + 1]) {
                this.$toasted.error('יש לבחור מתוך הרשימה!');
            }

            this.$emit('variant-changed', variant || null);
        }
    }
};
</script>
